/* assets/tr-color-profile.js (moved out of sections/truerim-color-profile.liquid 2026-10-22 so the browser caches it across the color pages). */
(function(){
  'use strict';
  var SID = (document.currentScript && document.currentScript.getAttribute('data-sid')) || '';
  if (!SID) { var h0 = document.querySelector('[data-trcp-head][id^="trcp-head-"]'); if (h0) SID = h0.id.slice(10); }   /* no data-sid (should not happen) */
  var head = document.getElementById('trcp-head-' + SID), body = document.getElementById('trcp-body-' + SID);
  if (!head || !body) return;
  var home = head.parentNode, layout = head.getAttribute('data-trcp-layout') || '';
  /* Description markers (2026-10-04 audit, DESCRIPTION-CONCEPTS.md §0.5). build-mockups.py parses these two objects and
     runs the same classifier over the fixtures, so keep them JSON (double quotes) and edit them here only. */
  var M = {"title": "OEM-Matched Paint", "lead": "A professional basecoat paint", "aero": "The aerosol is ready to use", "code": "OEM Paint Code:", "match": "What this matches:", "stage": "stage pearl finish.", "clear": "clear coat", "legal": "TrueRim is an independent brand"};
  var RX = {"year": "^(\\d{4}|late |early |mid)", "years": "^[\\d–\\-,\\s]+$", "note": "^(Offered across|Match the paint code|Factory wheel finish)", "notes": "^All .+ models$", "row": "^(\\s*)([^:]+?)(:\\s*)(Stage 1/2)(\\s+)(\\$[\\d,]+\\.\\d{2})(\\s*\\+\\s*)(Stage 2/2)(\\s+)(\\$[\\d,]+\\.\\d{2})(\\s*=\\s*)$", "total": "^\\s*(\\$[\\d,]+\\.\\d{2}) total\\s*$"};
  var REQUIRED = ['title', 'code', 'clear', 'legal'];
  var YEAR = new RegExp(RX.year, 'i'), YEARS = new RegExp(RX.years), NOTE = new RegExp(RX.note), NOTES = new RegExp(RX.notes);
  var ROW = new RegExp(RX.row), TOT = new RegExp(RX.total);

  var page, media, buy, grid, acc, box, more, live = false, st = {};
  function norm(s){ return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
  function leadNode(el){ var n = el.firstChild; while (n && n.nodeType === 3 && !/\S/.test(n.nodeValue)) n = n.nextSibling; return n; }
  function leadTag(el){ var n = leadNode(el); return n && n.nodeType === 1 ? n.tagName : ''; }
  function after(n){ var out = []; for (var x = n ? n.nextSibling : null; x; x = x.nextSibling) out.push(x); return out; }
  function cents(t){ return Math.round(parseFloat(String(t).replace(/[$,]/g, '')) * 100); }

  /* ---------- read-only parse: classifies the direct <p>/<ul> children of the description ---------- */
  function parse(el){
    var r = { blocks: [], kinds: {} }, kids = el.children;
    for (var i = 0; i < kids.length; i++) {
      var b = kids[i], t = norm(b.textContent), lt = leadTag(b), k = '';
      var sl = lt === 'STRONG' ? norm(leadNode(b).textContent) : '';
      if (b.tagName === 'P') {
        if (!r.kinds.title && lt === 'STRONG' && b.children.length === 1 && t === sl && t.slice(-M.title.length) === M.title) k = 'title';
        else if (sl === M.code) k = 'code';
        else if (sl === M.match) k = 'match';
        else if (sl && sl.slice(-M.stage.length) === M.stage) k = 'stage';
        else if (lt === 'EM' && t.indexOf(M.legal) >= 0) k = 'legal';
        else if (lt === 'EM' && t.indexOf(M.clear) >= 0) k = 'clear';
        else if (t.indexOf(M.lead) >= 0) k = 'lead';
        else if (t.indexOf(M.aero) >= 0) k = 'aero';
        else if (t && lt !== 'STRONG' && lt !== 'EM') k = 'story';
      } else if (b.tagName === 'UL' && r.blocks.length && r.blocks[r.blocks.length - 1].k === 'stage') k = 'stagelist';
      r.blocks.push({ el: b, k: k });
      if (k) r.kinds[k] = (r.kinds[k] || 0) + 1;
    }
    r.full = r.kinds.code === 1 && REQUIRED.every(function(k){ return r.kinds[k] >= 1; });
    return r;
  }

  /* ---------- decoration: classes and <span> wrappers around existing nodes; no text is added, removed or hidden ---------- */
  function wrap(nodes, cls){
    var s = document.createElement('span'); s.className = cls;
    nodes[0].parentNode.insertBefore(s, nodes[0]);
    nodes.forEach(function(n){ s.appendChild(n); });
    return s;
  }
  function trimLine(line){            /* keep edge whitespace outside the chip */
    var a = line[0], z = line[line.length - 1], m;
    if (a.nodeType === 3 && (m = /^\s+/.exec(a.nodeValue)) && m[0].length < a.nodeValue.length) line[0] = a.splitText(m[0].length);
    z = line[line.length - 1];
    if (z.nodeType === 3 && (m = /\s+$/.exec(z.nodeValue)) && m.index > 0) z.splitText(m.index);
    return line;
  }
  /* model lines are chips; year lines are plain tabular text next to their model, so they never read as a model */
  function chipClass(txt){ return YEAR.test(txt) || YEARS.test(txt) ? 'trcp-yrs' : 'trcp-chip'; }
  function chips(p){
    var lines = [], cur = [];
    after(leadNode(p)).forEach(function(n){
      if (n.nodeType === 1 && n.tagName === 'BR') { if (cur.length) lines.push(cur); cur = []; } else cur.push(n);
    });
    if (cur.length) lines.push(cur);
    lines.forEach(function(line){
      var txt = norm(line.map(function(n){ return n.textContent; }).join(''));
      if (!txt) return;
      line = trimLine(line);
      if (NOTE.test(txt) || NOTES.test(txt)) { wrap(line, 'trcp-mnote'); return; }
      if (line.length === 1 && line[0].nodeType === 3 && line[0].nodeValue.indexOf(' · ') > 0) {
        var tn = line[0], parts = tn.nodeValue.split(/( · )/), frag = document.createDocumentFragment();
        parts.forEach(function(s, i){
          if (!s) return;
          var sp = document.createElement('span');
          sp.className = i % 2 ? 'trcp-sep' : chipClass(s);
          if (i % 2) sp.setAttribute('aria-hidden', 'true');
          sp.appendChild(document.createTextNode(s));
          frag.appendChild(sp);
        });
        tn.parentNode.replaceChild(frag, tn);
        return;
      }
      wrap(line, chipClass(txt));
    });
  }
  function prices(){ try { return JSON.parse(body.getAttribute('data-trcp-prices') || 'null'); } catch (e) { return null; } }
  /* Stage price list -> table. Every row must parse and its total must equal that size's variant.price (and Stage 1/2 +
     Stage 2/2 = total); otherwise the list stays exactly as written. Prices are never recomputed or reformatted. */
  function table(ul){
    var P = prices(), rows = [];
    if (!P) return false;
    for (var i = 0; i < ul.children.length; i++) {
      var li = ul.children[i], tn = leadNode(li), stg = li.children[0];
      if (li.tagName !== 'LI' || li.children.length !== 1 || !tn || tn.nodeType !== 3 || !stg || stg.tagName !== 'STRONG') return false;
      var m = ROW.exec(tn.nodeValue), mt = TOT.exec(stg.textContent);
      if (!m || !mt || P[m[2]] == null || cents(mt[1]) !== P[m[2]] || cents(m[6]) + cents(m[10]) !== P[m[2]]) return false;
      rows.push({ tn: tn, st: stg, m: m });
    }
    if (!rows.length) return false;
    rows.forEach(function(r){
      var m = r.m, f = document.createDocumentFragment();
      function sp(cls, kids){ var s = document.createElement('span'); s.className = cls; kids.forEach(function(k){ s.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); }); return s; }
      if (m[1]) f.appendChild(document.createTextNode(m[1]));
      f.appendChild(sp('trcp-st-size', [m[2], sp('trcp-st-op', [m[3]])]));
      f.appendChild(sp('trcp-st-cell', [sp('trcp-st-k', [m[4]]), m[5], sp('trcp-st-amt', [m[6]])]));
      f.appendChild(sp('trcp-st-op', [m[7]]));
      f.appendChild(sp('trcp-st-cell', [sp('trcp-st-k', [m[8]]), m[9], sp('trcp-st-amt', [m[10]])]));
      f.appendChild(sp('trcp-st-op', [m[11]]));
      r.tn.parentNode.replaceChild(f, r.tn);
      r.st.classList.add('trcp-st-tot');
    });
    ul.classList.add('trcp-st');
    return true;
  }
  function decorate(r){
    r.blocks.forEach(function(b){
      if (!b.k) return;
      b.el.classList.add('trcp-d-' + b.k);
      if (b.k === 'code' || b.k === 'match' || b.k === 'stage') leadNode(b.el).classList.add('trcp-k');
      if (b.k === 'code') { var rest = after(leadNode(b.el)); if (rest.length) wrap(trimLine(rest), 'trcp-v'); }
      if (b.k === 'match') chips(b.el);
      if (b.k === 'stagelist') table(b.el);
    });
  }

  /* ---------- placement: desktop under the swatch, mobile head under the price and body after the kit ---------- */
  var mqM = window.matchMedia ? window.matchMedia('(max-width: 849px)') : null;
  var mqD = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  var mqS = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  /* Phones: the System / Years rows move (never copied) from the head into the body's <dl>, and the coat diagram into
     the body's figure slot, so the head above the kit is only name, code and finish. rowsHome() puts them back in their
     original order. */
  function rowsToBody(){
    if (!st.mrows || !st.mrows.length) return;
    st.mrows.forEach(function(r){ if (r.to) { r.to.appendChild(r.el); r.to.hidden = false; } });
  }
  function rowsHome(){
    if (!st.mrows) return;
    st.mrows.forEach(function(r){ r.parent.insertBefore(r.el, r.next && r.next.parentNode === r.parent ? r.next : null); });
    if (st.mdl) st.mdl.hidden = true;
    if (st.mfig) st.mfig.hidden = true;
  }
  function place(){
    if (!live) return;
    var mobile = !!(mqM && mqM.matches);
    if (mobile) {
      var facts = buy.querySelector('[data-trkb-facts]'), price = buy.querySelector('.trpd-price');
      if (facts && facts.parentNode) facts.parentNode.insertBefore(head, facts);
      else if (price && price.parentNode === buy) buy.insertBefore(head, price.nextSibling);
      else buy.insertBefore(head, buy.firstChild);
      page.insertBefore(body, grid.nextSibling);
    } else {
      media.appendChild(head);
      media.appendChild(body);
    }
    if (mqS && mqS.matches) rowsToBody(); else rowsHome();
    page.classList.toggle('trcp-split', mobile);
    measure();
  }
  function stickyTop(){
    var sh = document.querySelector('sticky-header[data-sticky-type="always"]');
    return (sh ? Math.round(sh.getBoundingClientRect().height) : 0) + 16;
  }
  /* Desktop only. Collapse: when the left column (description fully open) would run taller than the kit, clip the
     description below its title line and price table and show "Read full description". Sticky: the head sticks under
     the store header while it fits the viewport and the description is collapsed (an open one is being read). */
  /* Clip height: what makes the column end level with the kit, but never above the title line and price table (plus
     about two lines of the text after them) and never under 120px. */
  function clipHeight(fixed){
    var keep = 0, top = box.getBoundingClientRect().top;
    if (!page.classList.contains('trcp-raw')) {
      var k = box.querySelectorAll('.trcp-d-title, .trcp-d-stage, .trcp-d-stagelist');
      for (var i = 0; i < k.length; i++) keep = Math.max(keep, k[i].getBoundingClientRect().bottom - top);
    }
    return Math.round(Math.max(120, keep + 60, buy.offsetHeight - fixed));
  }
  function measure(){
    if (!live) return;
    var desk = !(mqM && mqM.matches), closed = acc.classList.contains('is-closed'), need = false;
    if (desk && !closed && more) {
      var extra = box.scrollHeight - box.offsetHeight;
      var natural = body.getBoundingClientRect().bottom - media.getBoundingClientRect().top + extra;
      var clipH = clipHeight(natural - box.scrollHeight);
      need = box.scrollHeight > clipH + 80 && natural > buy.offsetHeight;
      body.style.setProperty('--trcp-clip', clipH + 'px');
    }
    page.classList.toggle('trcp-clip', need && !st.open);
    if (more) more.hidden = !need;
    var top = stickyTop();
    var stick = !!(mqD && mqD.matches) && desk && body.getAttribute('data-trcp-sticky') === 'on' && !(need && st.open)
      && head.offsetHeight + top + 24 <= window.innerHeight;
    media.style.setProperty('--trcp-top', top + 'px');
    page.classList.toggle('trcp-stick', stick);
  }
  function onMore(){
    st.open = !st.open;
    more.setAttribute('aria-expanded', st.open ? 'true' : 'false');
    more.textContent = st.open ? 'Show less' : 'Read full description';
    measure();
    if (!st.open && more.getBoundingClientRect().top < 0 && more.scrollIntoView) more.scrollIntoView({ block: 'center' });
  }
  function hideFacts(){
    var f = document.querySelectorAll('[data-trkb-facts]');
    for (var i = 0; i < f.length; i++) if (!f[i].hasAttribute('data-trcp-hid')) { f[i].setAttribute('data-trcp-hid', ''); st.hid.push(f[i]); }
  }
  function onFaq(){
    var faq = document.getElementById('trcg-faq'), d = faq && faq.querySelector('details');
    if (d) d.open = true;
  }
  function pruneFaq(){
    if (document.getElementById('trcg-faq')) return;
    [head, body].forEach(function(root){
      var links = root.querySelectorAll('[data-trcp-faq]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i], w = a.closest('[data-trcp-faqw]') || a;
        if (w.parentNode) w.parentNode.removeChild(w);
      }
    });
  }

  /* ---------- undo: back to today's page exactly ---------- */
  function undo(){
    try {
      live = false;
      if (st.ro) st.ro.disconnect();
      if (mqM && st.onMq) { if (mqM.removeEventListener) mqM.removeEventListener('change', st.onMq); else if (mqM.removeListener) mqM.removeListener(st.onMq); }
      if (mqD && st.onMq) { if (mqD.removeEventListener) mqD.removeEventListener('change', st.onMq); else if (mqD.removeListener) mqD.removeListener(st.onMq); }
      if (mqS && st.onMq) { if (mqS.removeEventListener) mqS.removeEventListener('change', st.onMq); else if (mqS.removeListener) mqS.removeListener(st.onMq); }
      if (st.onRs) window.removeEventListener('resize', st.onRs);
      if (page) page.classList.remove('trcp-on', 'trcp-split', 'trcp-stick', 'trcp-clip', 'trcp-l-' + layout, 'trcp-raw');
      if (media) media.style.removeProperty('--trcp-top');
      body.style.removeProperty('--trcp-clip');
      rowsHome();
      if (more) { more.hidden = true; more.setAttribute('aria-expanded', 'false'); more.textContent = 'Read full description'; }
      if (box && st.html != null && box.innerHTML !== st.html) box.innerHTML = st.html;
      if (acc && st.accParent && acc.parentNode !== st.accParent) st.accParent.insertBefore(acc, st.accNext && st.accNext.parentNode === st.accParent ? st.accNext : null);
      (st.hid || []).forEach(function(f){ f.removeAttribute('data-trcp-hid'); });
      head.hidden = true; body.hidden = true;
      if (home && document.contains(home)) { home.appendChild(head); home.appendChild(body); }
    } catch (e) {}
  }

  /* ---------- boot: guards first (nothing touched on failure), then apply inside try ---------- */
  function boot(){
    page = document.querySelector('.trpd');
    media = page && page.querySelector('.trpd-media');
    buy = page && page.querySelector('.trpd-buy-col');
    grid = page && page.querySelector('.trpd-grid');
    acc = page && page.querySelector('[data-trpd-acc]');
    box = acc && acc.querySelector('.trpd-acc-body');
    var slot = body.querySelector('[data-trcp-slot="desc"]');
    if (!page || !media || !buy || !grid || !acc || !box || !slot || acc.parentNode !== page) return false;
    if (!head.hidden || !body.hidden || page.classList.contains('trcp-on')) return false;
    var r = parse(box);
    more = body.querySelector('[data-trcp-more]');
    st = { hid: [], accParent: acc.parentNode, accNext: acc.nextSibling, html: box.innerHTML, ro: null, open: false,
           mdl: body.querySelector('[data-trcp-mdl]'), mfig: body.querySelector('[data-trcp-mfigslot]'), mrows: [] };
    try {
      var mr = head.querySelectorAll('[data-trcp-mrow], [data-trcp-mfig]');
      for (var j = 0; j < mr.length; j++) {
        var nx = mr[j].nextElementSibling, fig = mr[j].hasAttribute('data-trcp-mfig');
        while (nx && (nx.hasAttribute('data-trcp-mrow') || nx.hasAttribute('data-trcp-mfig'))) nx = nx.nextElementSibling;
        st.mrows.push({ el: mr[j], parent: mr[j].parentNode, next: nx, to: fig ? st.mfig : st.mdl });
      }
      var before = norm(box.textContent);
      if (r.full) decorate(r);
      if (norm(box.textContent) !== before) throw new Error('trcp: description text changed while decorating');
      slot.appendChild(acc);
      live = true;
      place();
      hideFacts();
      head.hidden = false; body.hidden = false;
      page.classList.add('trcp-on', 'trcp-l-' + layout);
      if (!r.full) page.classList.add('trcp-raw');
      page.setAttribute('data-trcp-mode', r.full ? 'full' : 'raw');
      st.onMq = function(){ place(); };
      [mqM, mqD, mqS].forEach(function(q){ if (q) { if (q.addEventListener) q.addEventListener('change', st.onMq); else if (q.addListener) q.addListener(st.onMq); } });
      if (more) more.addEventListener('click', onMore);
      st.onRs = function(){ measure(); };
      window.addEventListener('resize', st.onRs);
      if (window.ResizeObserver) {
        /* measured on the next frame: measure() resizes observed nodes, which must not re-enter the observer */
        st.ro = new ResizeObserver(function(){
          if (st.raf) return;
          var go = function(){ st.raf = 0; measure(); };
          st.raf = window.requestAnimationFrame ? window.requestAnimationFrame(go) : setTimeout(go, 16);
        });
        st.ro.observe(media); st.ro.observe(buy); st.ro.observe(box);
      }
      measure();
      [head, body].forEach(function(root){ var a = root.querySelectorAll('[data-trcp-faq]'); for (var i = 0; i < a.length; i++) a[i].addEventListener('click', onFaq); });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruneFaq); else pruneFaq();
    } catch (err) {
      undo();
      return true;
    }
    return true;
  }
  if (!boot() && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(){ if (live) hideFacts(); });
  document.addEventListener('shopify:section:unload', function(e){
    if (!e.detail || e.detail.sectionId !== SID) return;
    undo();
    if (head.parentNode) head.parentNode.removeChild(head);
    if (body.parentNode) body.parentNode.removeChild(body);
  });
})();
